import React from 'react';

import { ToolTip } from '../../components/tool-tip';
import { OtherScore, YourScore } from '../../atoms/tool-tips';

export interface Props {
  data: any[];
  isDefined?: (d: any) => boolean;
  isEstimated?: (d: any) => boolean;
  name?: (d: any, index: number) => string;
  value?: (d: any) => number;
  yScale?: (d: any) => number;
}

const ident = x => x;

class PointMarkers extends React.Component<Props, any> {
  static defaultProps: Props = {
    data: [],
    isDefined: () => true,
    isEstimated: () => false,
    name: ident,
    value: ident,
    yScale: ident,
  };

  public render() {
    const { data, isDefined, isEstimated, name, value, yScale } = this.props;
    const definedData = data.filter(isDefined);
    const maxY = Math.max(...definedData.map(d => Math.abs(value(d))));

    if (!definedData.length) {
      return null;
    }

    const markers = data.map((d, i) => {
      const rank = i === 0 ? 'major' : 'minor';
      const Tip = i === 0 ? YourScore : OtherScore;
      const r = i === 0 ? 5 : 4;

      return (
        isDefined(d) &&
        !isEstimated(d) && (
          <ToolTip
            key={`${rank}-${i}`}
            svg={true}
            graph={true}
            tooltip={<Tip score={value(d)} title={name(d, i)} />}
          >
            <circle className={`marker ${rank}`} r={r} cy={yScale(value(d))} />
          </ToolTip>
        )
      );
    });

    return (
      <g className="markers">
        <line className="anchor marker" y2={yScale(maxY)} />
        {markers.reverse()}
      </g>
    );
  }
}

export default PointMarkers;
